const inject = (accountId) => {
  (function(w, t, f) {
    let s = "script", o = "_giosg", h = "https://service.giosg.com", e, n;
    e = t.createElement(s);
    e.async = 1;
    e.src = h + "/live2/" + f;
    w[o] = w[o] || function() {
      (w[o]._e = w[o]._e || []).push(arguments);
    };
    w[o]._c = f;
    w[o]._h = h;
    n = t.getElementsByTagName(s)[0];
    n.parentNode.insertBefore(e, n);
  })(window, document, accountId);
};

const show = () => {
  if (window && window.giosg_telephony) {
    window.giosg_telephony.shown = true;
    window.giosg_telephony.views.Customer.switchTo();
  }
};
const hide = () => {
  if (window && window.giosg_telephony) {
    window.giosg_telephony.shown = false;
  }
};

export { hide, inject, show };
//# sourceMappingURL=b2x-giosg.esm.js.map
